import { NodeSelection } from "@tiptap/pm/state";

/**
 * Insert a block image after the current selection without replacing a selected image.
 * Fixes: uploading a second image while the first is still selected used to replace it.
 */
export function insertImageSmart(editor, attrs) {
  const { state } = editor;
  const { selection } = state;

  let pos = selection.to;

  if (selection instanceof NodeSelection && selection.node.type.name === "image") {
    pos = selection.from + selection.node.nodeSize;
  }

  return editor.chain().focus().insertContentAt(pos, { type: "image", attrs }).run();
}
